import { isError } from 'flux-standard-action';
import { normalize } from 'normalizr';
import defaultsDeep from 'lodash/defaultsDeep';
import { vodContent as vodContentSchemas } from 'app-webtech-core/schemas';
import { metaExtractor, payloadExtractor } from 'app-webtech-core/reducers/payloadExtractor';
import { updateState } from 'app-webtech-core/reducers/updateState';

const { VodContentSchema } = vodContentSchemas;

const successMutationGenerator = ({ seasons }, { seriesId }) => ({
  entities: (currentEntities) => {
    const seriesToMutate = {
      ...currentEntities.vodContent[seriesId],
      seasons,
      loadingSeasons: false,
    };

    const { entities } = normalize([seriesToMutate], [VodContentSchema]);
    entities.vodContent = { ...entities.vodContent, ...entities.vodEpisodes };

    return defaultsDeep({}, currentEntities, entities);
  },
});

const errorMutationGenerator = (error, { seriesId }) => ({
  entities: {
    vodContent: {
      $auto: {
        [seriesId]: {
          loadingSeasons: { $set: false },
        },
      },
    },
  },
});

export const vodContentFetchSeriesSeasonsSuccessReducer = (currentState, action) =>
  updateState(
    currentState,
    (isError(action) ? errorMutationGenerator : successMutationGenerator)(
      payloadExtractor(action),
      metaExtractor(action),
    ),
  );

export const vodContentFetchSeriesSeasonsFailureReducer = (currentState, action) =>
  updateState(
    currentState,
    errorMutationGenerator(payloadExtractor(action), metaExtractor(action)),
  );
